// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ListItemIcon":"bci_a bhr_ke","ListItemIcon--empty":"bci_b bhr_fl"};